import { defineMessages } from 'react-intl';
import { createTestLabel as createTestLabelAction } from '../../csw.actions';

const messages = defineMessages({
  printTestLabel: {
    description: 'Button text about printing an example test shipping label',
    defaultMessage: 'Print a test label',
    id: 'cjtvVK',
  },
});

export const createTestLabel = {
  id: 'createTestLabel',
  translation: messages.printTestLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId) => {
    return createTestLabelAction(fulfillmentPlanId);
  },
};
